import { AUTH_ROUTE_ID } from '@/integrations/tanstack-router/auth-route-id';

export const NOTICE_ROUTES = {
  index: '/notice',
} as const;

export const NOTICE_ROUTE_IDS = {
  index: `/${AUTH_ROUTE_ID}${NOTICE_ROUTES.index}`,
} as const;
